import { useMemo } from 'react';
import { useObservableEagerState } from 'observable-hooks';
import { AppTypes } from '../enums';
import { useClientService } from './use-services';
export var useIsGorillaTheme = function() {
    var clientService = useClientService();
    var appType = useObservableEagerState(clientService.appType$);
    return useMemo(function() {
        return appType === AppTypes.auth || appType === AppTypes.client;
    }, [
        appType
    ]);
};
